import React from 'react'
import { AppBar, Layout } from 'react-admin'
import CustomAppBar from './navbar.js'

const CustomLayout = (props) => <Layout {...props} appBar={CustomAppBar} />

export default CustomLayout
